<template>
  <div id="index-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">
        <div class="boxContent">

          <h1>Vítejte na stránkách Salonu Jája</h1>

          <p>
            Jsme psí salon, který poskytuje vašim čtyřnohým mazlíčkům
            tyto <router-link to="/service">služby</router-link>: <b>koupání</b>
            a <b>stříhání psů</b>, <b>trimování</b>, <b>psí masáže</b>, <b>rozčesávání</b>,
						<b>úpravu drápků</b>, <b>ošetření uší a očí</b>. Dále
						nabízíme poradenství v oblasti výchovy a výcviku psů nebo po
						dohodě s námi splnění jiných nadstandardních přání.
					</p>

          <p>
            Salon slouží zároveň jako kamenný obchod, takže si u
            nás můžete zakoupit různé kosmetické či jiné potřeby pro
            pejsky a kočičky.
          </p>

          <p>
            Naše provozovna se nachází na adrese Pražského
            662, Praha 5 - Hlubočepy (Barrandov), kdy vchod do
            salonu je umístěn z boku domu, více informací o tom jak se k
            nám dostat spolu s mapkou přesného umístění naleznete v <router-link to="/contact">kontaktech</router-link>.
					</p>

          <p>
            Pokud chcete blíže poznat prostředí salonu, před tím, než do
            něj přivedete svého psího miláčka, <router-link to="/about">zde</router-link> naleznete fotografie interiéru salonu
						a i našich psích a jednoho kočíčího mazla, kteří se zdají
						býti naším hýčkáním nadmíru spokojeni ;-)
					</p>

          <p>
            Salon Jája zavedl prodej <b>dárkových poukazů</b>, kterými mohou páníčkové obdarovat své psí miláčky
						nebo touto formou obdarovat majitele pejska a udělat tak radost oběma.
						Dárkové poukazy zahrnují veškeré inzerované služby v uvedené ceně.
						Bližší informace naleznete v sekci <router-link to="/voucher">Dárkové poukazy</router-link>.
					</p>

          <p>
            V případě jakýchkoliv dotazů či připomínek nás neváhejte
            <router-link to="/contact">kontaktovat</router-link>.
					</p>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>




      <div class="box">
        <div class="boxTitle">
          <h2>Před a po stříhání</h2>
        </div>
        <div class="boxContent">

          <div class="photo200">

            <a :href="require('../../../static/photos/index/1_pred.jpg')" class="photo fancybox" rel="group" title="Před stříháním"><span class="image"><span><img src="../../../static/photos/index/thumb_1_pred.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/index/1_po.jpg')" class="photo fancybox" rel="group" title="Po stříhání"><span class="image"><span><img src="../../../static/photos/index/thumb_1_po.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/index/2_pred.jpg')" class="photo fancybox" rel="group" title="Před stříháním"><span class="image"><span><img src="../../../static/photos/index/thumb_2_pred.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/index/2_po.jpg')" class="photo fancybox" rel="group" title="Po stříhání"><span class="image"><span><img src="../../../static/photos/index/thumb_2_po.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/index/3_pred.jpg')" class="photo fancybox" rel="group" title="Před stříháním"><span class="image"><span><img src="../../../static/photos/index/thumb_3_pred.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/index/3_po.jpg')" class="photo fancybox" rel="group" title="Po stříhání"><span class="image"><span><img src="../../../static/photos/index/thumb_3_po.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/index/4_pred.jpg')" class="photo fancybox" rel="group" title="Před stříháním"><span class="image"><span><img src="../../../static/photos/index/thumb_4_pred.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/index/4_po.jpg')" class="photo fancybox" rel="group" title="Po stříhání"><span class="image"><span><img src="../../../static/photos/index/thumb_4_po.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/index/5_pred.jpg')" class="photo fancybox" rel="group" title="Před stříháním"><span class="image"><span><img src="../../../static/photos/index/thumb_5_pred.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/index/5_po.jpg')" class="photo fancybox" rel="group" title="Po stříhání"><span class="image"><span><img src="../../../static/photos/index/thumb_5_po.jpg" width="200"/></span></span></a>

          </div>

          <div class="cleaner">
            <!-- / -->
          </div>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  import fancybox from './../../assets/js/fancybox'

  export default {
    name: 'index-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'koupání, trimování a stříhání psů' },
      meta: [
        { id: 'description', content: 'Psí salon Jája poskytuje koupání a stříhání psů, trimování, úpravu drápků, ošetření uší a očí. Navštivte nás na adrese Pražského 662, Praha 5 – Barrandov.' },
        { id: 'keywords', content: 'psí, salon, stříhaní, koupaní, trimování' }
      ]
    },
    mounted () {
      fancybox('#index-view .fancybox')
    }
  }
</script>



// WEBPACK FOOTER //
// IndexView.vue?4ae6965d